// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  AccountTreeOutlined,
  ArticleOutlined,
  AutoAwesomeMotionOutlined,
  Groups2,
  NotificationsActiveOutlined,
  PersonOutline,
  PhonelinkSetupOutlined,
  SoupKitchenOutlined,
  SyncAltOutlined,
  TabletMacOutlined
} from '@mui/icons-material';
import enums from 'utils/enums';

// icons
const icons = {
  PersonOutline,
  AccountTreeOutlined,
  ArticleOutlined,
  SyncAltOutlined,
  PhonelinkSetupOutlined,
  NotificationsActiveOutlined,
  Groups2,
  TabletMacOutlined,
  SoupKitchenOutlined,
  AutoAwesomeMotionOutlined
};

// ==============================|| MENU ITEMS - MAIN ||============================== //
const admin = {
  id: 'admin',
  type: 'group',
  title: <FormattedMessage id='admin' />,
  roleTags: [enums.userRole.CJAdmin, enums.userRole.SuperAdmin, enums.userRole.User, enums.userRole.SiteManager],
  children: [
    {
      id: 'sync',
      title: <FormattedMessage id='sync' />,
      type: 'item',
      url: 'dashboard/sync',
      icon: icons.SyncAltOutlined,
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin],
      isShowFilter: true,
      showTitle: false,
      isExternal: false
    },
    {
      id: 'systemUserList',
      title: <FormattedMessage id='systemUserList' />,
      subTitle: 'Manage Users',
      type: 'item',
      url: 'admin/users',
      icon: icons.PersonOutline,
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin],
      isShowFilter: true,
      showTitle: true,
    },
    {
      id: 'sitelist',
      title: <FormattedMessage id='sitelist' />,
      subTitle: 'Manage Sites',
      type: 'item',
      url: 'admin/sites',
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.User, enums.userRole.SiteManager],
      icon: icons.AccountTreeOutlined,
      isShowFilter: true,
      showTitle: true,
    },
    {
      id: 'rules',
      title: <FormattedMessage id='rules' />,
      subTitle: 'Manage Rules',
      type: 'item',
      url: 'admin/rules',
      icon: icons.ArticleOutlined,
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin],
      isShowFilter: true,
      showTitle: true,
    },
    {
      id: 'devices',
      title: <FormattedMessage id='devices' />,
      subTitle: 'Manage Devices',
      type: 'item',
      url: 'admin/devices',
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin],
      icon: icons.TabletMacOutlined,
      isShowFilter: true,
      showTitle: true,
    },
    {
      id: 'kds',
      title: <FormattedMessage id='kds' />,
      subTitle: 'KDS Setup',
      type: 'item',
      url: 'admin/kds',
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin],
      icon: icons.SoupKitchenOutlined,
      isShowFilter: true,
      showTitle: true,
    },
  ]
};

export default admin;
